import { hasTeamRole } from '@greenroom/shared'
import { LinkButton } from '../components/ui/button'
import { useQuery } from '@tanstack/react-query'
import { RecordingList } from '../components/recording-list'
import { PageHeader } from '../components/ui/misc'
import { FullPageSpinner } from '../components/ui/spinner'
import { useCurrentTeam } from '../lib/auth'
import { q } from '../lib/queries'
import { useTitle } from '../lib/title'
import { QueryError } from './errors'

export function RecordingsPage() {
  const { team } = useCurrentTeam()
  useTitle('Recordings', team.name)
  const recordings = useQuery(q.recordings(team.id))
  return (
    <>
      <PageHeader title="Recordings" subtitle={`Every session recorded in ${team.name}'s studios.`} actions={hasTeamRole(team.role, 'producer') && <LinkButton to="/recordings/import">Import recording</LinkButton>} />
      {recordings.isPending ? (
        <FullPageSpinner />
      ) : recordings.isError ? (
        <QueryError error={recordings.error} retry={recordings.refetch} what="list" />
      ) : (
        <RecordingList recordings={recordings.data} showStudio />
      )}
    </>
  )
}
